module.exports = __webpack_public_path__ + "static/img/00_arab_spring.a537744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moments/00_arab_spring.png
// module id = QBA6
// module chunks = 1